import { TextareaInlineField } from '../../../Textarea'
import { Control } from '../Control'

function ControlJson({ value, onChange, ...controlProps }) {
  function handleChange(nextValue) {
    onChange(value, { value: JSON.parse(nextValue) })
  }

  return (
    <Control {...controlProps} value={value} onChange={onChange}>
      <TextareaInlineField
        autoResizeHeight
        borderless
        withoutManualResize
        disabled={value.omitted}
        value={JSON.stringify(value.value ?? null, null, 2)}
        onChange={handleChange}
      />
    </Control>
  )
}

export default ControlJson
